import { Input, Component, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AbstractValueAccessor, MakeProvider } from './abstract-value-accessor';
import { FormField } from '../models/form-field';

@Component({
  selector: 'edx-link-field',
  providers: [MakeProvider(LinkFieldComponent)],
  styleUrls: ['dynamic-form-field.component.scss'],
  template: `
  <div class="textfield fullwidth" [formGroup]="form" [title]="value">
    @if (isFile()) {
      <a target="_blank" download [href]="value">{{field.checkLabel}}</a>
    }
    @if (!isFile()) {
      <a target="_blank" [href]="value" [tabindex]="tabIndex">{{field.checkLabel}}</a>
    }
  </div>
  `,
  standalone: false
})
export class LinkFieldComponent extends AbstractValueAccessor implements OnChanges {
  @Input() field: FormField;
  @Input() form: FormGroup;
  @Input() tabIndex = 0;

  ngOnChanges() {
    this.value = this.form.controls[this.field.name].value;
  }

  public isFile(): boolean {
    return this.field.format === 'download';
  }
}
